export type FormulaFunction = (...args: any[]) => any
export type FormulaFunctionMap = Record<string, FormulaFunction>

export const builtinFunctions: FormulaFunctionMap = {
  sum: (...args: any[]) => args.reduce((a, b) => a + b, 0),
  avg: (...args: any[]) => (args.length ? args.reduce((a, b) => a + b, 0) / args.length : 0),
  min: (...args: any[]) => Math.min(...args),
  max: (...args: any[]) => Math.max(...args),
  round: (v: number, d: number = 0) => Number(v.toFixed(d)),
  if: (cond: any, t: any, f: any) => (cond ? t : f),
  // 성과 지수 계산을 위한 수치 적분 함수들
  integrate: (func: Function, a: number, b: number, n: number = 1000) => {
    // 사다리꼴 적분법 (Trapezoidal Rule)
    const h = (b - a) / n
    let sum = (func(a) + func(b)) / 2
    for (let i = 1; i < n; i++) {
      sum += func(a + i * h)
    }
    return sum * h
  },

  beta_integrand: (t: number, alpha: number, beta: number) => {
    // 베타 분포 피적분함수: t^(α-1) × (1-t)^(β-1)
    return Math.pow(t, alpha - 1) * Math.pow(1 - t, beta - 1)
  },

  incomplete_beta: (x: number, alpha: number, beta: number) => {
    // 불완전 베타 함수 계산
    const func = (t: number) => Math.pow(t, alpha - 1) * Math.pow(1 - t, beta - 1)
    const h = x / 1000
    let sum = (func(0) + func(x)) / 2
    for (let i = 1; i < 1000; i++) {
      sum += func(i * h)
    }
    return sum * h
  },

  complete_beta: (alpha: number, beta: number) => {
    // 완전 베타 함수 계산
    const func = (t: number) => Math.pow(t, alpha - 1) * Math.pow(1 - t, beta - 1)
    const h = 1 / 1000
    let sum = (func(0) + func(1)) / 2
    for (let i = 1; i < 1000; i++) {
      sum += func(i * h)
    }
    return sum * h
  },

  performance_index: (x: number, alpha1: number, beta1: number, alpha2: number, beta2: number) => {
    // 성과 지수 계산: 1 - (불완전 베타 / 완전 베타)
    const numerator = builtinFunctions.incomplete_beta(x, alpha1, beta1)
    const denominator = builtinFunctions.complete_beta(alpha2, beta2)
    return 1 - numerator / denominator
  },

  // 지수 함수들
  exp: (x: number) => Math.exp(x),
  log: (x: number) => Math.log(x),
  pow: (x: number, y: number) => Math.pow(x, y),

  // 지수 감쇠 성과 지수
  exponential_decay: (value: number, scale: number, power: number) => {
    // exp(-(value / scale)^power)
    return Math.exp(-Math.pow(value / scale, power))
  }
  // 필요시 확장
}
